import { render } from "./AutoDialerApplications.vue?vue&type=template&id=08b7dfac"
import script from "./AutoDialerApplications.vue?vue&type=script&lang=js"
export * from "./AutoDialerApplications.vue?vue&type=script&lang=js"

import "./AutoDialerApplications.vue?vue&type=style&index=0&id=08b7dfac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__